export enum GatewayServiceEnum {
    GET_WEBSITE_BY_ID = 'getWebsiteById',
    REGISTER_FOR_TESTING = 'registerForTesting',
    APPLY_FOR_AGREEMENT_BUSINESS = 'applyForAgreementBusiness',
    APPLY_FOR_AGREEMENT_PRIVATE = 'applyForAgreementPrivate',
    APPLY_FOR_AGREEMENT_BUSINESS_REGISTER_WEBSITE = 'applyForAgreementBusinessRegisterWebsite',
    APPLY_FOR_AGREEMENT_PRIVATE_REGISTER_WEBSITE = 'applyForAgreementPrivateRegisterWebsite',
    WEBSITE_ALLOWED_FOR_REGISTER = 'websiteAllowedForRegister'
}
